import React from 'react';

const TechnologyHome = () => (
    <div className="container-fluid" style={{paddingTop: '40px'}}>
        <div className="text-center">
            <i
                className="fa fa-cogs"
                style={{fontSize: '90px', color: '#2e6da4'}}
            />
            <h1>Tecnología TGLE</h1>
            <h4>Innovación que conecta la operación de TGLE</h4>

            <hr style={{maxWidth: '650px'}} />

            <p>
                Centro de gestión de iniciativas, requerimientos y
                proyectos tecnológicos.
            </p>

            <p className="text-muted">
                Roadmap · Proyectos · Calendario · Documentación
            </p>
        </div>
    </div>
);

export default TechnologyHome;
